import React from 'react';
import PropTypes from 'prop-types';

import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";

import { withStyles } from '@material-ui/core';

const styles = theme => ({
  paper: {
    padding: theme.spacing.unit * 2,
    backgroundColor: '#CDDFFC'
  },
  button: {
    backgroundColor: 'white',
    color: 'black',
    marginLeft: 16,
  },
  container: {
    height: '100%',
  }
});

const Banner = ({
  children,
  // actions is an array of either
  // * props to be passed to each Button
  // * valid react elements
  actions = [],
  classes,
  paperStyle,
  center
}) => (
  <Paper elevation={0} square className={paperStyle? paperStyle : classes.paper} >
    <Grid container justify='space-between' alignItems='center' classes={{container:classes.container}}>
      {center && 
        <Grid item />
      }
      <Grid item>
        {children}
      </Grid>
      <Grid item>
        {actions.map((action, index) => (
          React.isValidElement(action)
          ? action
          : <Button 
              key={index}
              variant='contained' 
              className={classes.button}
              {...action}
            />
        ))}
      </Grid>
    </Grid>
  </Paper>
);

Banner.propTypes = {
  actions: PropTypes.array,
}

export default withStyles(styles)(Banner);


// WEBPACK FOOTER //
// ./src/components/Banner.js